import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, RowsSkeletonLoader, Timeline, type TimelineProps } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { useGetPaymentLimitHistory } from 'hooks/queries/useGetPaymentLimitHistory'
import { buildDescription, buildTitle, getEntryVariant } from './paymentLimitActivityUtils'

interface PaymentLimitActivityTabProps {
  limitId: string | undefined
}

export const PaymentLimitActivityTab = ({ limitId }: PaymentLimitActivityTabProps) => {
  const { t } = useTranslation()
  const { data: history, isLoading, isError, refetch } = useGetPaymentLimitHistory(limitId)

  if (!limitId) {
    return null
  }

  if (isLoading) {
    return <RowsSkeletonLoader rows={3} />
  }

  if (isError) {
    return <RequestErrorStatusCard onReload={refetch} />
  }

  if (!history?.length) {
    return (
      <Box paddingT={16} width="full">
        <p className="text-body-regular text-foreground-prominent">
          {t('paymentLimits.activity.noActivity')}
        </p>
      </Box>
    )
  }

  const items: TimelineProps['items'] = history.map(entry => ({
    id: entry.id,
    date: entry.updatedAt ? new Date(entry.updatedAt) : undefined,
    variant: getEntryVariant(entry.level),
    Title: buildTitle(entry, t),
    description: buildDescription(entry, t),
  }))

  return (
    <Box paddingT={16} width="full">
      <Timeline items={items} full />
    </Box>
  )
}
